/* Linea Garden — datalayer (lato browser).
   Il contesto della pagina e il consenso di partenza li scrive lo snippet
   lg-datalayer.liquid, in testa al <head>. Qui c'e' quello che dipende da cio' che
   il cliente fa: carrello, configuratore, liste, assistente.

   Regola di questo file: NON tocca la logica di nessun altro. Il carrello e la
   buy-box restano come sono; gli eventi si prendono avvolgendo le funzioni
   pubbliche e ascoltando i clic. Se questo file non viene caricato, il negozio
   funziona esattamente come prima. */
(function () {
  'use strict';

  var DL = window.LG_DL || {};
  var VALUTA = DL.valuta || 'EUR';
  function push(o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); }
  function ecom(evento, ecommerce) {
    push({ ecommerce: null });
    push({ event: evento, ecommerce: ecommerce });
    meta(evento, ecommerce);
  }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }

  /* ---------------------------------------------------------------- consenso
     Il banner e' quello nativo di Shopify. Qui si traduce la sua risposta nei
     quattro segnali di Google. Una scelta sola del cliente, valida per tutti. */
  function applicaConsenso(c) {
    if (!c) return;
    var analytics = c.analyticsProcessingAllowed ? 'granted' : 'denied';
    var marketing = c.marketingAllowed ? 'granted' : 'denied';
    gtag('consent', 'update', {
      analytics_storage: analytics,
      ad_storage: marketing,
      ad_user_data: marketing,
      ad_personalization: marketing
    });
    push({ event: 'lg_consenso', lg_consenso_analytics: analytics, lg_consenso_marketing: marketing });
    if (marketing === 'granted') caricaMeta();
    if (analytics === 'granted') caricaClarity();
  }

  function statoConsenso() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return null;
    try {
      return {
        analyticsProcessingAllowed: cp.analyticsProcessingAllowed(),
        marketingAllowed: cp.marketingAllowed()
      };
    } catch (e) { return null; }
  }

  /* L'evento che descrive la pagina parte SOLO dopo che il consenso e' stato
     risolto. Tag Manager valuta un tag nel momento in cui l'evento arriva: se
     arrivasse prima, lo troverebbe negato e non lo riguarderebbe piu'.
     Costato una mezza giornata di tag che non sparavano, il 5/9/2026. */
  var paginaDichiarata = false;

  function dichiaraPagina() {
    if (paginaDichiarata) return;
    paginaDichiarata = true;
    var ev = DL.eventoPagina;
    if (!ev) return;
    push({ ecommerce: null });
    push(ev);
    meta(ev.event, ev.ecommerce);
  }

  function avviaConsenso() {
    // Chi ha gia' scelto in una visita precedente non rivede il banner: il suo
    // consenso va riapplicato subito, altrimenti resterebbe negato per sempre.
    var subito = statoConsenso();
    if (subito) {
      applicaConsenso(subito);
      dichiaraPagina();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) applicaConsenso(statoConsenso());
        dichiaraPagina();
      });
    } else {
      dichiaraPagina();
    }
    // Se la Customer Privacy API non risponde, la pagina si dichiara lo stesso:
    // i tag resteranno fermi perche' il consenso e' negato, ed e' giusto cosi',
    // ma il dato resta nel dataLayer e l'analisi interna lo vede.
    setTimeout(dichiaraPagina, 2500);
    // E quando sceglie adesso, dal banner.
    document.addEventListener('visitorConsentCollected', function () { applicaConsenso(statoConsenso()); });
  }

  /* ------------------------------------------------------------------ articoli
     Una riga del carrello parla la lingua di GA4. Il prezzo e' quello del telo
     configurato: metri quadri x euro al metro quadro, arrotondato ai centesimi,
     lo stesso conto che rifa' il server quando crea l'ordine. */
  function mq(it) { return round2(num(it.h) * num(it.w) / 10000); }

  function itemDaRiga(it, indice) {
    var area = mq(it);
    var unit = num(it.unit) || (DL.prezzoM2 ? num(DL.prezzoM2[it.fili]) : 0);
    var o = {
      item_id: it.handle || '',
      item_name: it.design || it.title || '',
      item_brand: 'Linea Garden',
      item_variant: it.color || '',
      price: round2(area * unit),
      quantity: it.qty || 1,
      lg_sku: it.sku || '',
      lg_variant_id: it.variantId ? String(it.variantId).replace(/^.*\//, '') : '',
      lg_altezza_cm: num(it.h),
      lg_larghezza_cm: num(it.w),
      lg_mq: area,
      lg_fili: num(it.fili),
      lg_prezzo_m2: unit
    };
    if (DL.item && DL.item.item_id === o.item_id) {
      o.item_category = DL.item.item_category;
      o.item_category2 = DL.item.item_category2;
      o.item_category3 = DL.item.item_category3;
    }
    if (typeof indice === 'number') o.index = indice + 1;
    return o;
  }

  function valore(items) {
    var t = 0;
    for (var i = 0; i < items.length; i++) t += num(items[i].price) * (items[i].quantity || 1);
    return round2(t);
  }

  /* ------------------------------------------------------------------ carrello
     LGCart non viene modificato: le sue funzioni pubbliche vengono avvolte.
     L'originale viene chiamato per primo e il suo risultato restituito intatto;
     se l'evento fallisse, il carrello continuerebbe a funzionare. */
  function avvolgiCarrello() {
    var C = window.LGCart;
    if (!C || C.__lgdl) return false;
    C.__lgdl = true;

    var add = C.add;
    C.add = function (it) {
      var esito = add.apply(this, arguments);
      try {
        var item = itemDaRiga(esito || it);
        ecom('add_to_cart', { currency: VALUTA, value: valore([item]), items: [item] });
      } catch (e) {}
      return esito;
    };

    var remove = C.remove;
    C.remove = function (id) {
      var riga = null;
      try {
        var righe = C.items();
        for (var i = 0; i < righe.length; i++) if (righe[i].id === id) riga = righe[i];
      } catch (e) {}
      var esito = remove.apply(this, arguments);
      try {
        if (riga) {
          var item = itemDaRiga(riga);
          ecom('remove_from_cart', { currency: VALUTA, value: valore([item]), items: [item] });
        }
      } catch (e) {}
      return esito;
    };

    var setQty = C.setQty;
    C.setQty = function (id, q) {
      var prima = 0, riga = null;
      try {
        var righe = C.items();
        for (var i = 0; i < righe.length; i++) if (righe[i].id === id) { riga = righe[i]; prima = riga.qty || 1; }
      } catch (e) {}
      var esito = setQty.apply(this, arguments);
      try {
        if (riga) {
          var dopo = Math.max(1, parseInt(q, 10) || 1);
          var delta = dopo - prima;
          if (delta !== 0) {
            var copia = JSON.parse(JSON.stringify(riga));
            copia.qty = Math.abs(delta);
            var item = itemDaRiga(copia);
            ecom(delta > 0 ? 'add_to_cart' : 'remove_from_cart', { currency: VALUTA, value: valore([item]), items: [item] });
          }
        }
      } catch (e) {}
      return esito;
    };

    var checkout = C.checkout;
    C.checkout = function () {
      try {
        var items = C.items().map(function (it, i) { return itemDaRiga(it, i); });
        if (items.length) ecom('begin_checkout', { currency: VALUTA, value: valore(items), items: items });
      } catch (e) {}
      return checkout.apply(this, arguments);
    };

    // Il pannello si apre anche da dentro il carrello (dopo un'aggiunta, o dal
    // clic sull'icona): quella e' una funzione interna, non questa. Per non
    // perdere l'apertura vera si ascolta il clic, e una guardia di mezzo secondo
    // evita di contarla due volte quando passa anche di qui.
    var open = C.open;
    C.open = function () {
      emettiViewCart();
      return open.apply(this, arguments);
    };

    return true;
  }

  // LGCart si registra da uno script in fondo alla pagina: se non c'e' ancora,
  // si riprova per un paio di secondi invece di rinunciare.
  function attendiCarrello() {
    if (avvolgiCarrello()) return;
    var tentativi = 0;
    var t = setInterval(function () {
      if (avvolgiCarrello() || ++tentativi > 40) clearInterval(t);
    }, 50);
  }

  /* ---------------------------------------------------------- vista del carrello
     Tre modi di arrivarci: il clic sull'icona, la chiamata pubblica open(), e la
     pagina /pages/carrello. Un solo evento per volta. */
  var ultimoViewCart = 0;

  function emettiViewCart() {
    var ora = Date.now();
    if (ora - ultimoViewCart < 500) return;
    ultimoViewCart = ora;
    try {
      var items = (window.LGCart ? window.LGCart.items() : []).map(function (it, i) { return itemDaRiga(it, i); });
      ecom('view_cart', { currency: VALUTA, value: valore(items), items: items });
    } catch (e) {}
  }

  function ascoltaAperturaCarrello() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-lg-cart-open]');
      if (t) emettiViewCart();
    }, true);
  }

  function vistaPaginaCarrello() {
    if (!document.querySelector('[data-lg-cart-page]')) return;
    emettiViewCart();
  }

  /* --------------------------------------------------------------------- liste
     select_item: il clic su una card. I dati esatti stanno in data-lg-item
     (card nostre); per le card di Kalles nella ricerca si ripesca l'articolo
     dalla lista gia' dichiarata, usando l'indirizzo del prodotto. */
  function handleDaUrl(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function itemDaAttributi(el) {
    var o = {
      item_id: el.getAttribute('data-lg-id') || '',
      item_name: el.getAttribute('data-lg-nome') || '',
      item_brand: 'Linea Garden',
      item_category: el.getAttribute('data-lg-categoria') || '',
      price: num(el.getAttribute('data-lg-prezzo')),
      quantity: 1
    };
    var stile = el.getAttribute('data-lg-stile');
    if (stile) o.item_category2 = stile;
    return o;
  }

  function itemDaCard(a) {
    var card = a.closest('[data-lg-id]');
    if (card) return itemDaAttributi(card);
    var h = handleDaUrl(a.getAttribute('href') || a.href);
    if (h && DL.lista && DL.lista.items) {
      for (var i = 0; i < DL.lista.items.length; i++) if (DL.lista.items[i].item_id === h) return DL.lista.items[i];
    }
    return h ? { item_id: h, quantity: 1 } : null;
  }

  function ascoltaListe() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a) return;
      var item = itemDaCard(a);
      if (!item) return;
      ecom('select_item', {
        item_list_id: (DL.lista && DL.lista.item_list_id) || DL.tipoPagina || '',
        item_list_name: (DL.lista && DL.lista.item_list_name) || '',
        items: [item]
      });
    }, true);
  }

  /* La collezione carica le pagine successive senza cambiare indirizzo: ogni
     lotto nuovo e' una lista che nessuno ha ancora dichiarato. */
  function osservaCaricamentoProgressivo() {
    var griglia = document.querySelector('.lg-pgrid[data-grid]');
    if (!griglia || !window.MutationObserver) return;
    var attesa = null, lotto = [];
    new MutationObserver(function (mutazioni) {
      mutazioni.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var n = m.addedNodes[i];
          if (n.nodeType !== 1) continue;
          if (!n.getAttribute || !n.getAttribute('data-lg-id')) continue;
          lotto.push(itemDaAttributi(n));
        }
      });
      if (!lotto.length) return;
      clearTimeout(attesa);
      attesa = setTimeout(function () {
        var items = lotto.slice(); lotto = [];
        if (!items.length) return;
        ecom('view_item_list', {
          item_list_id: (DL.lista && DL.lista.item_list_id) || '',
          item_list_name: (DL.lista && DL.lista.item_list_name) || '',
          items: items
        });
      }, 250);
    }).observe(griglia, { childList: true });
  }

  /* -------------------------------------------------------------- configuratore
     Nessun aggancio dentro la buy-box: si ascoltano i suoi comandi dal documento.
     I listener sono in fase di cattura perche' la buy-box, sul 'change', corregge
     l'altezza fuori scala: in fase di risalita leggerei il valore gia' corretto e
     non saprei mai che il cliente ne aveva chiesto un altro. */
  var configAvviata = false, ultimaConfig = '';

  function statoConfig() {
    var h = document.querySelector('[data-h]'), l = document.querySelector('[data-l]');
    var fili = document.querySelector('.lg-fili button.is-on');
    return {
      h: h ? num(h.value) : 0,
      w: l ? num(l.value) : 0,
      fili: fili ? num(fili.getAttribute('data-fili')) : 4
    };
  }

  function datiConfig(st) {
    var area = round2(st.h * st.w / 10000);
    var unit = DL.prezzoM2 ? num(DL.prezzoM2[st.fili]) : 0;
    return {
      lg_design: DL.item ? DL.item.item_name : '',
      lg_altezza_cm: st.h,
      lg_larghezza_cm: st.w,
      lg_mq: area,
      lg_fili: st.fili,
      lg_prezzo_m2: unit,
      lg_prezzo_telo: round2(area * unit)
    };
  }

  function ascoltaConfiguratore() {
    if (!document.querySelector('[data-h]')) return;

    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-h],[data-l]')) return;
      if (configAvviata) return;
      configAvviata = true;
      push({ event: 'lg_config_avviata', lg_design: DL.item ? DL.item.item_name : '', lg_colore: DL.item ? DL.item.item_variant : '' });
    }, true);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-h],[data-l]')) return;
      var chiesto = num(t.value);
      var eAltezza = t.matches('[data-h]');
      var min = eAltezza ? 60 : 1, max = eAltezza ? 220 : 3500;
      if (chiesto > 0 && (chiesto < min || chiesto > max)) {
        push({
          event: 'lg_misura_fuori_scala',
          lg_misura: eAltezza ? 'altezza' : 'larghezza',
          lg_valore_chiesto: chiesto,
          lg_minimo: min,
          lg_massimo: max
        });
      }
      // Il valore definitivo lo decide la buy-box subito dopo: si guarda al giro
      // successivo del ciclo di eventi, quando la correzione e' gia' avvenuta.
      setTimeout(function () {
        var st = statoConfig();
        if (!(st.h > 0 && st.w > 0)) return;
        var firma = st.h + 'x' + st.w + 'x' + st.fili;
        if (firma === ultimaConfig) return;
        ultimaConfig = firma;
        var dati = datiConfig(st);
        push(Object.assign({ event: 'lg_config_completata' }, dati));
        clarityEtichetta('design', dati.lg_design);
        clarityEtichetta('fili', dati.lg_fili);
      }, 0);
    }, true);

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.lg-fili button[data-fili]');
      if (!b) return;
      var prima = statoConfig().fili;
      var dopo = num(b.getAttribute('data-fili'));
      if (prima === dopo) return;
      push({ event: 'lg_fili_cambiati', lg_fili_prima: prima, lg_fili_dopo: dopo, lg_design: DL.item ? DL.item.item_name : '' });
    }, true);
  }

  /* ---------------------------------------------------------------- assistente
     Il modale e' un iframe su un altro dominio: si accettano messaggi solo dalla
     sua origine, come fa gia' lo snippet del consulente. Finche' l'app non li
     invia, questi eventi semplicemente non partono. */
  function ascoltaAssistente() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-lg-consulente]');
      if (!t) return;
      push({
        event: 'lg_assistente_aperto',
        lg_design: DL.item ? DL.item.item_name : '',
        lg_codice_design: t.getAttribute('data-design') || ''
      });
    }, true);

    window.addEventListener('message', function (e) {
      var fr = document.querySelector('iframe.lgc-fr');
      if (!fr) return;
      var origine = '';
      try { origine = new URL(fr.src).origin; } catch (err) { return; }
      if (e.origin !== origine) return;
      var d = e.data;
      if (!d || typeof d.type !== 'string' || d.type.indexOf('lg-consulente:') !== 0) return;
      if (d.type === 'lg-consulente:domanda') {
        push({ event: 'lg_assistente_domanda', lg_argomento: d.argomento || '', lg_codice_design: d.codice || '' });
      }
    });
  }

  /* -------------------------------------------------------- Meta e Clarity
     Non passano da Tag Manager. Come tag Custom HTML non partivano — e senza la
     modalita' anteprima del container non si vede il perche'. Qui il consenso lo
     conosciamo con precisione e il risultato si verifica a occhio: due pezzi in
     meno fra il fatto e la misura. In GTM restano Google e GA4, che funzionano. */
  var META_ID = '370509359214805';
  var CLARITY_ID = 'l9rjpbyse8';
  var metaPronto = false, clarityPronto = false;

  function caricaMeta() {
    if (metaPronto || window.fbq) { metaPronto = true; return; }
    metaPronto = true;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', META_ID);
    window.fbq('track', 'PageView');
  }

  function caricaClarity() {
    if (clarityPronto || window.clarity) { clarityPronto = true; return; }
    clarityPronto = true;
    /* eslint-disable */
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_ID);
    /* eslint-enable */
  }

  // Meta vuole un evento per volta, con lo stesso nome che usa lui.
  var META_EVENTI = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };

  function meta(evento, ecommerce) {
    if (!metaPronto || !window.fbq) return;
    var nome = META_EVENTI[evento];
    if (!nome) return;
    var primo = (ecommerce && ecommerce.items && ecommerce.items[0]) || {};
    window.fbq('track', nome, {
      content_type: 'product',
      content_name: String(primo.item_name || ''),
      content_ids: [String(primo.lg_sku || primo.item_id || '')],
      value: Number((ecommerce && ecommerce.value) || primo.price) || 0,
      currency: VALUTA
    });
  }

  function clarityEtichetta(chiave, valore) {
    if (!clarityPronto || !window.clarity || !valore) return;
    try { window.clarity('set', chiave, String(valore)); } catch (e) {}
  }

  /* ------------------------------------------------------------ attribuzione
     L'acquisto avviene sul checkout di Shopify, dentro una sandbox che non vede
     i cookie del sito: da li' ogni cliente sembrerebbe arrivato dal nulla. Qui
     si raccoglie chi e' il visitatore secondo Google e Meta, e lo si consegna
     all'ordine; sara' il server, a ordine creato, a dirlo alle due piattaforme.

     Nessun dato personale: sono identificativi tecnici del browser, gli stessi
     che il sito usa gia' per contare le visite. Se il consenso manca, i cookie
     non esistono e questi campi restano vuoti. */
  var CHIAVE_CLIC = 'lg_clic_v1';

  function cookie(nome) {
    var m = document.cookie.match('(^|;\\s*)' + nome + '=([^;]*)');
    return m ? decodeURIComponent(m[2]) : '';
  }

  function clientIdGA() {
    // _ga = GA1.1.<client_id>  →  il client_id sono gli ultimi due pezzi
    var v = cookie('_ga');
    var p = v.split('.');
    return p.length >= 4 ? p[2] + '.' + p[3] : '';
  }

  function sessionIdGA() {
    // _ga_<CONTENITORE> = GS2.1.s<sessione>$o<n>$g...  →  serve il numero dopo "s"
    for (var i = 0; i < document.cookie.split(';').length; i++) {
      var c = document.cookie.split(';')[i].trim();
      if (c.indexOf('_ga_') !== 0) continue;
      var m = /s(\d{6,})/.exec(c);
      if (m) return m[1];
    }
    return '';
  }

  // I codici delle campagne arrivano nell'indirizzo di atterraggio e non ci sono
  // piu' quando il cliente paga: si mettono da parte al primo passaggio.
  function memorizzaCodiciCampagna() {
    try {
      var q = new URLSearchParams(location.search);
      var salvati = JSON.parse(localStorage.getItem(CHIAVE_CLIC) || '{}');
      var cambiato = false;
      ['gclid', 'wbraid', 'gbraid', 'fbclid', 'ttclid', 'msclkid'].forEach(function (k) {
        var v = q.get(k);
        if (v) { salvati[k] = v; salvati.quando = Date.now(); cambiato = true; }
      });
      if (cambiato) localStorage.setItem(CHIAVE_CLIC, JSON.stringify(salvati));
    } catch (e) {}
  }

  /* ---------------------------------------------------- da dove arriva
     Per il test di vendita (piano del 20/10/2026) ogni progetto deve sapere
     citta', canale e campagna di chi l'ha aperto. I codici UTM stanno solo
     nell'indirizzo d'atterraggio: qui si mettono da parte il PRIMO contatto
     esterno (la campagna che ha portato il cliente) e l'ULTIMO (quella da
     cui e' tornato), e gli iframe dell'app li ricevono come `?prov=`.
     Nessun dato personale: nomi di campagna, host di provenienza, pagina.
     Vale 30 giorni, quanto un progetto. */
  var CHIAVE_PROV = 'lg_prov_v1';
  var PROV_GIORNI = 30;

  function toccoCorrente() {
    var q = new URLSearchParams(location.search), t = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = q.get(k);
      if (v) t[k.slice(4)] = v.slice(0, 100);
    });
    ['gclid', 'wbraid', 'gbraid', 'fbclid', 'ttclid', 'msclkid'].forEach(function (k) {
      if (q.get(k) && !t.clic) t.clic = k;
    });
    try {
      var da = document.referrer ? new URL(document.referrer).host : '';
      if (da && da !== location.host) t.da = da.slice(0, 100);
    } catch (e) {}
    t.pagina = location.pathname.slice(0, 100);
    t.quando = Date.now();
    return t;
  }

  function memorizzaProvenienza() {
    try {
      var tocco = toccoCorrente();
      var esterno = !!(tocco.source || tocco.campaign || tocco.clic || tocco.da);
      var s = JSON.parse(localStorage.getItem(CHIAVE_PROV) || '{}');
      var scaduto = !s.primo || !s.primo.quando || (Date.now() - s.primo.quando) > PROV_GIORNI * 86400000;
      // La prima visita si registra sempre, anche diretta: altrimenti chi arriva
      // scrivendo l'indirizzo non avrebbe mai una provenienza. Poi si aggiorna
      // solo «ultimo», e solo quando arriva da fuori.
      if (scaduto) s = { primo: tocco, ultimo: tocco };
      else if (esterno) s.ultimo = tocco;
      else return;
      localStorage.setItem(CHIAVE_PROV, JSON.stringify(s));
    } catch (e) {}
  }

  function traccia() {
    var codici = {};
    try { codici = JSON.parse(localStorage.getItem(CHIAVE_CLIC) || '{}'); } catch (e) {}
    var stato = statoConsenso() || {};
    return {
      ga_client_id: clientIdGA(),
      ga_session_id: sessionIdGA(),
      fbp: cookie('_fbp'),
      fbc: cookie('_fbc'),
      gclid: codici.gclid || '',
      wbraid: codici.wbraid || '',
      fbclid: codici.fbclid || '',
      pagina: location.pathname,
      consenso_analytics: !!stato.analyticsProcessingAllowed,
      consenso_marketing: !!stato.marketingAllowed
    };
  }

  /* ------------------------------------------------------------ ordine fallito
     Il carrello avvisa con un alert e rimette il pulsante com'era: non emette
     nulla di suo. Si intercetta la chiamata all'endpoint del pagamento. */
  function ascoltaCheckout() {
    if (!window.fetch) return;
    var originale = window.fetch;
    window.fetch = function (risorsa, opzioni) {
      var url = (typeof risorsa === 'string') ? risorsa : (risorsa && risorsa.url) || '';
      // Al carrello non si chiede nulla: la traccia si aggiunge qui, alla
      // richiesta che sta gia' partendo verso l'endpoint del pagamento.
      if (url && url.indexOf('/api/checkout') > -1 && opzioni && typeof opzioni.body === 'string') {
        try {
          var corpo = JSON.parse(opzioni.body);
          corpo.traccia = traccia();
          opzioni = Object.assign({}, opzioni, { body: JSON.stringify(corpo) });
          arguments[1] = opzioni;
        } catch (e) {}
      }
      var promessa = originale.apply(this, arguments);
      if (url && url.indexOf('/api/checkout') > -1) {
        promessa.then(function (r) {
          if (!r.ok) push({ event: 'lg_checkout_fallito', lg_stato: r.status });
        }).catch(function () {
          push({ event: 'lg_checkout_fallito', lg_stato: 'rete' });
        });
      }
      return promessa;
    };
  }

  function avvia() {
    avviaConsenso();
    attendiCarrello();
    ascoltaAperturaCarrello();
    vistaPaginaCarrello();
    ascoltaListe();
    osservaCaricamentoProgressivo();
    ascoltaConfiguratore();
    ascoltaAssistente();
    memorizzaCodiciCampagna();
    memorizzaProvenienza();
    ascoltaCheckout();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
